import React, {Component} from 'react';
import axios from 'axios';
import {FaCloud} from "react-icons/fa";
import { connect } from 'react-redux';
import {Alert} from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { Card, CardBody, Row } from 'reactstrap';
import InputSpinner from "react-bootstrap-input-spinner";
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";

class OrderAddonVpsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            vps: {},
            error: false,
            messageError: '',
            errorForm: false,
            messageErrorForm: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            isSpinner: false,
            listAddon: {},
            configBilling: {
                'monthly' : '1 Tháng',
                'twomonthly' : '2 Tháng',
                'quarterly' : '3 Tháng',
                'semi_annually' : '6 Tháng',
                'annually' : '1 Năm',
                'biennially' : '2 Năm',
                'triennially' : '3 Năm',
                'one_time_pay' : 'Vĩnh viễn',
                'free' : 'Miễn phí',
            },
            addonCpu: 0,
            addonRam: 0,
            addonDisk: 0,
            btnSubmit: true,
            sub_total: 0
        }
    }

    componentDidMount() {
        document.querySelector('.cr-sidebar').classList.add('cr-sidebar--open');
        window.scrollTo(0, 0);
        this.getConfigAddonVps(this.props.vpsId);
        // this.loadPricing();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if (this.props.isNotification) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getConfigAddonVps = (vpsId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/order/getConfigAddonVps/' + vpsId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data.listAddon);
                if (ref.data.error === 0) {
                    this.setState({
                        loadPage: false,
                        isLoading: false,
                        listAddon: ref.data.listAddon,
                        vps: ref.data.vps,
                        btnSubmit: false,
                    })
                } else {
                    if (ref.data.error >= 9000) {
                        this.props.logOut();
                    }
                    else if (ref.data.error >= 8000) {
                        this.redirectHome(ref.data.message);
                    }
                    else {
                        this.setState({
                            loadPage: false,
                            isLoading: false,
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu sản phẩm thất bại',
                })
            })
    }

    addCommas = (nStr) => {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            // eslint-disable-next-line no-useless-concat
            x1 = x1.replace(rgx, '$1' + '.' + '$2');
        }
        return x1 + x2;
    }

    loadConfig  = () => {
        if ( Object.keys(this.state.vps).length ) {
            return (
                <>
                    IP: { this.state.vps.ip } <br/>
                    Cấu hình: { this.state.vps.text_config } <br/>
                    Hệ điều hành: { this.state.vps.text_os } <br/>
                    Thời gian thuê: { this.state.vps.text_billing_cycle } <br/>
                    Ngày kết thúc: { this.state.vps.text_next_due_date } <br/>
                </>
            )
        }
    }

    loadAddonVps = () => {
        if ( !this.state.listAddon.error ) {
            // console.log(this.state.listAddon.addonCpu)
            return (
                <div className="form-group addon-product mt-4 mb-4">
                    <label htmlFor="addon">Chọn gói Addon</label>
                    <div className="row">
                        <div className="col-md-4 addon text-center">
                            <label>CPU</label>
                            {
                                Object.keys(this.state.listAddon.addonCpu).length ? (
                                    <>
                                        <InputSpinner
                                            type={'int'}
                                            precision={2}
                                            max={20}
                                            min={0}
                                            step={1}
                                            value={0}
                                            onChange={ (num) =>  this.changeAddonCpu(num) }
                                            variant={'dark'}
                                            // size="sm"
                                        />
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </div>
                        <div className="col-md-4 addon text-center">
                            <label>RAM</label>
                            {
                                Object.keys(this.state.listAddon.addonRam).length ? (
                                    <>
                                        <InputSpinner
                                            type={'int'}
                                            precision={2}
                                            max={20}
                                            min={0}
                                            step={1}
                                            value={0}
                                            onChange={ (num) =>  this.changeAddonRam(num) }
                                            variant={'dark'}
                                            // size="sm"
                                        />
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </div>
                        <div className="col-md-4 addon text-center">
                            <label>DISK</label>
                            {
                                Object.keys(this.state.listAddon.addonDisk).length ? (
                                    <>
                                        <InputSpinner
                                            type={'int'}
                                            precision={2}
                                            max={200}
                                            min={0}
                                            step={10}
                                            value={0}
                                            onChange={ (num) =>  this.changeAddonDisk(num) }
                                            variant={'dark'}
                                            // size="sm"
                                        />
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </div>
                    </div>
                </div>
            )
        }
    }

    changeAddonCpu = async (num) => {
        if (!this.state.listAddon.error) {
            await this.setState({
                addonCpu: num
            })
            await this.loadPricing();
        }
    }

    changeAddonRam = async (num) => {
        if (!this.state.listAddon.error) {
            await this.setState({
                addonRam: num
            })
            await this.loadPricing();
        }
    }

    changeAddonDisk = async (num) => {
        if (!this.state.listAddon.error) {
            await this.setState({
                addonDisk: num
            })
            await this.loadPricing();
        }
    }

    loadPricing = () => {
        if ( !this.state.listAddon.error ) {
            // console.log(this.state.listAddon.addonCpu)
            let pricingAddonRam = 0;
            let pricingAddonCpu = 0;
            let pricingAddonDisk = 0;
            // sub total
            if ( !this.state.special && !this.state.listAddon.error ) {
                if ( this.state.addonRam || this.state.addonCpu || this.state.addonDisk ) {
                    if (Object.keys(this.state.listAddon.addonCpu).length) {
                        pricingAddonCpu = this.state.addonCpu * this.state.listAddon.addonCpu.product_pricing[ 'monthly' ] * this.state.vps.coefficient;
                    }
                    if (Object.keys(this.state.listAddon.addonRam).length) {
                        pricingAddonRam = this.state.addonRam * this.state.listAddon.addonRam.product_pricing[ 'monthly' ] * this.state.vps.coefficient;
                    }
                    if (Object.keys(this.state.listAddon.addonDisk).length) {
                        pricingAddonDisk = this.state.addonDisk * this.state.listAddon.addonDisk.product_pricing[ 'monthly' ]  * this.state.vps.coefficient / 10;
                    }
                }
            }
            let sub_total = pricingAddonCpu + pricingAddonRam + pricingAddonDisk;
            this.setState({
                sub_total: sub_total
            })
        }
    }

    redirect = (orderId) => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Tạo đơn hàng nâng cấp VPS thành công'
        });
        this.props.shouldRedirect(orderId);
    }

    redirectHome = (message) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.redirectHome();
    }

    submit = () => {
        this.setState({
            btnSubmit: true,
        })
        if ( this.validate() ) {
            this.setState({
                loadPage: true,
            })
            let dataAuth = {
                username: process.env.REACT_APP_CLIENT_ID,
                password: process.env.REACT_APP_CLIENT_PASSWD,
                token: process.env.REACT_APP_KEY,
            };
            let form = {
                vpsId: this.props.vpsId,
                addonCpu: this.state.addonCpu,
                addonRam: this.state.addonRam,
                addonDisk: this.state.addonDisk,
            };
            axios.post( process.env.REACT_APP_API_URL + '/api/order/createOrderAddonVps', form,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization' : this.props.token,
                        'dataAgency' : JSON.stringify(dataAuth)
                    }
                }
            )
                .then( (ref) => {
                    // console.log(ref.data);
                    this.setState({
                        loadPage: false,
                        isLoading: false,
                    });
                    if (ref.data.error === 0) {
                        this.redirect( ref.data.orderId );
                    } else {
                        if (ref.data.error > 9000) {
                            this.props.logOut();
                        }
                        else if ( ref.data.error >= 8000 ) {
                            this.redirectHome( ref.data.message );
                        }
                        else {
                            this.setState({
                                btnSubmit: false,
                                errorForm: true,
                                messageErrorForm: ref.data.message,
                            })
                        }
                    }
                    // console.log(this.state.perPage);
                })
                .catch( (error) => {
                    console.log(error);
                    this.setState({
                        btnSubmit: false,
                        loadPage: false,
                        isLoading: false,
                        errorForm: true,
                        messageErrorForm: 'Tạo đơn đặt hàng thất bại',
                    })
                })
        }
    }

    validate = () => {
        if ( !this.state.addonCpu && !this.state.addonRam && !this.state.addonDisk ) {
            this.setState({
                btnSubmit: false,
                errorForm: true,
                messageErrorForm: 'Không được bỏ trong 1 trong 3 loại Addon VPS. Quý khách vui lòng kiểm tra lại',
            })
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Đặt hàng Cloud VPS"} page={"Cloud Vps"}
                                        icon={<FaCloud className="breadcrumb-icon"/>}/>
                            {
                                this.state.error ? (
                                    <Alert color="danger">
                                        <div className='text-center'>
                                            {this.state.messageError}
                                        </div>
                                    </Alert>
                                ) : (
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                {
                                                    this.state.errorForm ? (
                                                        <div className="col-12 col-lg-12">
                                                            <Alert color="danger">
                                                                { this.state.messageErrorForm }
                                                            </Alert>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )
                                                }
                                                <div className="col-12 col-lg-7">
                                                    <div className="product-info rounded">
                                                        <p className="product-title">
                                                            VPS { this.state.vps.ip }
                                                        </p>
                                                        <p className="config-product">
                                                            {
                                                                this.loadConfig()
                                                            }
                                                        </p>
                                                    </div>
                                                    {
                                                        this.loadAddonVps()
                                                    }
                                                </div>
                                                <div className="col-12 col-lg-5">
                                                    <div className="detail-order">
                                                        <div className="title-detail-order">
                                                            Tóm tắt đơn hàng
                                                        </div>
                                                        <div className="order-summary">
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    !this.state.special && this.state.addonCpu ? (
                                                                        <div className="item">
                                                                            <div className="itemtitle">
                                                                                { this.state.listAddon.addonCpu.name }
                                                                            </div>
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.addonCpu  } Cores
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.addonCpu * this.state.listAddon.addonCpu.product_pricing[ 'monthly' ]  * this.state.vps.coefficient ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    !this.state.special && this.state.addonRam ? (
                                                                        <div className="item">
                                                                            <div className="itemtitle">
                                                                                { this.state.listAddon.addonRam.name }
                                                                            </div>
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.addonRam  } GB
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.addonRam * this.state.listAddon.addonRam.product_pricing[ 'monthly' ]  * this.state.vps.coefficient ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="addon-item-cpu">
                                                                {
                                                                    !this.state.special && this.state.addonDisk ? (
                                                                        <div className="item">
                                                                            <div className="itemtitle">
                                                                                { this.state.listAddon.addonDisk.name }
                                                                            </div>
                                                                            <div className="row">
                                                                                <div className="col col-md-6 item_billing">
                                                                                    { this.state.addonDisk  } GB SSD
                                                                                </div>
                                                                                <div className="col col-md-6 item_pricing text-right">
                                                                                    { this.addCommas( this.state.addonDisk * this.state.listAddon.addonDisk.product_pricing[ 'monthly' ]  * this.state.vps.coefficient / 10 ) } ₫
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="order-summary-total">
                                                                <div className="row">
                                                                    <div className="col-md-4">Tổng cộng</div>
                                                                    <div className="col-md-8 text-right">{ this.addCommas( this.state.sub_total ) } ₫</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="button_submit text-center">
                                                            <button type="button" className="btn btn-block btn-primary"
                                                                    disabled={ this.state.btnSubmit }
                                                                    onClick={ () => this.submit() }
                                                            >
                                                                Đặt hàng
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                )
                            }
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        user: state.user.user,
        credit: state.user.credit,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerOrderAddon' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderAddonVpsComponent);